/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/ResourceItem/Active/Post
 * @desc Active node component for ResourceItem
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';

export const FilterPostNewIndexResourceItemActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'experiments.protocolValues.resourceItem',
  );
  const filterActive = filter.isNodeActive(node);
  if (!filterActive) {
    return null;
  }

  const attributes = filter.getAttributeValues(node);

  return (
    <ReadOnMountHOC
      entityName={ResourceItem.entityName}
      type="entities"
      params={{
        id: attributes.guid.value,
        get_single: 1,
      }}
      loading={false}
      children={({ entity }) => {
        if (!entity) {
          return null;
        }
        return (
          <RemoveLabel
            icon={ICONS.resource_item.primary}
            name={entity.name}
            onRemoveClick={onRemoveClick}
          />
        );
      }}
    />
  );
};
